import EmojiPicker, { EmojiClickData } from 'emoji-picker-react';
import React, { useState } from 'react';

import Card from '../../../components/Card';
import { KOLColorPaletteCard } from '../components/KOLColorPaletteCard';

const colorPairs = [
  { light: '#FAEACA', dark: '#856B39' },
  { light: '#FADCCA', dark: '#936042' },
  { light: '#FBDAE5', dark: '#803F55' },
  { light: '#F2DEF4', dark: '#6E4872' },
  { light: '#DEEDF4', dark: '#3E6678' },
  { light: '#E2F4DE', dark: '#3D5737' },
];

export interface ColorPair {
  light: string;
  dark: string;
}

interface KOLColorAndEmojiValue {
  color?: ColorPair;
  emoji?: string;
}

interface KOLColorAndEmojiPresenterProps {
  value?: KOLColorAndEmojiValue;
  onChange?: (value: KOLColorAndEmojiValue) => void;
}

export const KOLColorAndEmojiPresenter = ({ value, onChange }: KOLColorAndEmojiPresenterProps) => {
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  const handleColorSelect = (colorValue: ColorPair) => {
    onChange?.({ ...value, color: colorValue });
  };

  const onEmojiClick = (emojiData: EmojiClickData) => {
    onChange?.({ ...value, emoji: emojiData.emoji });
    setIsEmojiPickerOpen(false);
  };

  const toggleEmojiPicker = () => {
    setIsEmojiPickerOpen(!isEmojiPickerOpen);
  };

  return (
    <Card className="flex flex-col space-y-8">
      <div className="text-22">
        Color Palette & Emoji <span className="text-colorsBrandRed01Primary">*</span>
      </div>

      <div className="flex flex-col space-y-12">
        {/* Color Palette Section */}
        <div className="space-y-4">
          <div className="flex flex-wrap gap-x-24 gap-y-6" role="radiogroup" aria-label="Color palette">
            {colorPairs.map((color) => (
              <KOLColorPaletteCard
                key={color.light}
                lightColor={color.light}
                darkColor={color.dark}
                isSelected={value?.color?.light === color.light}
                onClick={() => handleColorSelect(color)}
              />
            ))}
          </div>
        </div>

        {/* Emoji Section */}
        <div className="space-y-4">
          <div className="text-18 font-semibold">Emoji</div>
          <div className="relative">
            <button type="button" onClick={toggleEmojiPicker} className="w-[100px] h-[54px] btn btn-outline rounded-full bg-componentsBgBase flex items-center justify-center">
              {value?.emoji ? <span className="text-4xl">{value.emoji}</span> : <span className="text-systemGrays02LabelSecondary font-tt font-semibold">select emoji</span>}
            </button>

            {isEmojiPickerOpen && (
              <div className="absolute top-full left-0 right-0 z-50 mt-2 bg-componentsBgBase border border-systemGrays02LabelSecondary rounded-lg shadow-lg">
                <EmojiPicker onEmojiClick={onEmojiClick} width={'100%'} className="bg-componentsBgBase" />
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
